import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API, mediaUrl } from "@/lib/api";
import useDocumentTitle from "@/hooks/useDocumentTitle";

export default function Articles() {
  useDocumentTitle("Articles");
  const [items, setItems] = useState(null); // null=loading, []=empty
  useEffect(() => {
    axios.get(`${API}/content/articles`, { params: { limit: 50 } })
      .then(r => setItems(r.data || []))
      .catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="articles-page">
      <section className="container-wide pt-16 pb-8">
        <div className="font-accent text-[10px]" style={{ color: "var(--gi-gold)" }}>Articles</div>
        <h1 className="mt-3 font-heading text-5xl sm:text-6xl leading-[1.02]" style={{ color: "var(--gi-maroon)" }}>Articles &amp; Essays</h1>
        <div className="hair-divider my-8 max-w-xs" />
      </section>
      <section className="container-wide pb-24">
        {items === null && <p className="text-sm" style={{ color: "var(--gi-muted)" }}>Loading…</p>}
        {items?.length === 0 && (
          <p className="text-sm" style={{ color: "var(--gi-muted)" }} data-testid="articles-empty">No articles are published yet. Please check back shortly.</p>
        )}
        {items?.length > 0 && (
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
            {items.map(a => <ArticleCard key={a.id} a={a} />)}
          </div>
        )}
      </section>
    </div>
  );
}

const ArticleCard = ({ a }) => {
  const bodyPresent = Boolean((a.body || "").trim() || (a.summary || "").trim());
  const content = (
    <article className="bento-card h-full" data-testid={`article-card-${a.slug || a.id}`}>
      {a.featured_image && (
        <div className="aspect-[3/2] border mb-4 overflow-hidden" style={{ borderColor: "var(--gi-border)" }}>
          <img src={mediaUrl(a.featured_image)} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
        </div>
      )}
      <div className="font-accent text-[10px]" style={{ color: "var(--gi-gold)" }}>{a.category || "Article"}</div>
      <h3 className="mt-3 font-heading text-xl" style={{ color: "var(--gi-charcoal)" }}>{a.title}</h3>
      <p className="mt-2 text-xs" style={{ color: "var(--gi-muted)" }}>
        {[a.author, a.published_at && new Date(a.published_at).toLocaleDateString(), a.reading_time].filter(Boolean).join(" · ")}
      </p>
      {a.summary && <p className="mt-3 text-sm leading-relaxed" style={{ color: "var(--gi-charcoal-2)" }}>{a.summary}</p>}
    </article>
  );
  return bodyPresent && a.slug
    ? <Link to={`/articles/${a.slug}`} className="block hover:opacity-90 transition-opacity">{content}</Link>
    : content;
};
